<template>
    <div class="flex justify-center items-center" v-if="hasCalendly">
        <div class="w-full" ref="calendly" style="height: 675px;"></div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import _get from 'lodash/get';

    export default {
        data() {
            return {
            }
        },

        created() {
            window.addEventListener('message', event => {
                if (this.isEventScheduled(event)) {
                    this.$store.commit('modal', 'calendly-scheduled');
                }
            });
        },

        mounted() {
            if (this.hasCalendly) {
                this.initiateCalendly();
            }
        },

        computed: {

            formattedPhoneNumber() {
                return this.leadPhone.startsWith('1')
                    ? this.leadPhone
                    : `1${this.leadPhone}`;
            },

            prefill() {
                return {
                    email: this.leadEmail,
                    name: this.leadName,
                    customAnswers: {
                        a1: this.formattedPhoneNumber,
                    }
                };
            },

            ...mapGetters([
                'calendlyUrl',
                'hasCalendly',
                'leadEmail',
                'leadHash',
                'leadName',
                'leadPhone',
            ])
        },

        methods: {
            initiateCalendly() {
                Calendly.initInlineWidget({
                    url: this.calendlyUrl,
                    parentElement: this.$refs.calendly,
                    prefill: this.prefill,
                    utm: {
                        utmSource: 'ULH',
                        utmMedium: 'modal',
                        utmContent: this.leadHash,
                    }
                });
            },

            isEventScheduled(event) {
                return _get(event, 'data.event', false) === 'calendly.event_scheduled';
            },
        }
    }
</script>
